import styles from "./AddPhoneNumberForm.module.scss";
import { FormProvider, SubmitHandler } from "react-hook-form";
import { DefaultButton } from "../../button/defaultButton/DefaultButton";
import { nameof } from "ts-simple-nameof";
import { IAddPhoneNumberFormModel } from "../models/addPhoneNumberFormModel";
import { DefaultPhoneInputField } from "../../forms/inputs/phoneField/DefaultPhoneInputField";
import { useAddPhoneNumberForm } from "../hooks/useAddPhoneNumberForm";
import { useAppContext } from "../../../../AppContext";
import { normalizePhone } from "../../forms/inputs/phoneField/utils/PhoneInputUtility";
import { useApiMutation } from "../../../infrastructure/hooks/useApiMutation";
import { endpointsMetadata } from "../../../infrastructure/routes/endpointsMetadata";
import { useAuthenticationFunctions } from "../../../../components/authentication/utils/AuthenticationUtility";
import { IUserModel } from "../../../infrastructure/hooks/useAuthentication";
import { useNavigate } from "react-router";

interface IAddPhoneNumberFormProps {
  returnUrl?: string;
}

export const AddPhoneNumberForm = ({ returnUrl }: IAddPhoneNumberFormProps) => {
  const { isMobile } = useAppContext();
  const { onSuccessfulUserLogin } = useAuthenticationFunctions();
  const { currentUser, logout } = useAppContext();
  const form = useAddPhoneNumberForm();
  const { mutate } = useApiMutation();
  const navigate = useNavigate();

  const inputMaxWidth = isMobile ? "100%" : "350px";

  const onSave: SubmitHandler<IAddPhoneNumberFormModel> = async (data) => {
    if (data.phoneNumber) {
      data.phoneNumber = normalizePhone(data.phoneNumber)!;
    }

    mutate(
      {
        endpoint: endpointsMetadata.authentication.setPhoneNumber,
        globalIsLoading: true,
        method: "post",
        disableSuccessToast: true,
        ...data,
      },
      {
        onSuccess: (response: unknown) => {
          // If response contains login data, a merge happened - use the new credentials
          const loginResponse = response as IUserModel | undefined;
          if (loginResponse?.authToken) {
            onSuccessfulUserLogin(
              {
                ...loginResponse,
                phoneNumber: data.phoneNumber,
              },
              returnUrl
            );
          } else if (!!currentUser) {
            // No merge - just update the current user with the phone number
            onSuccessfulUserLogin(
              {
                ...currentUser,
                phoneNumber: data.phoneNumber,
              },
              returnUrl
            );
          }
        },
      }
    );
  };

  const logoutToAppointmentWizard = () => {
    logout();
    navigate(0);
  };

  return (
    <FormProvider {...form}>
      <p>
        За да можем да завършим регистрацията Ви, ще ни трябва телефонният Ви
        номер.
      </p>

      <form onSubmit={form.handleSubmit(onSave)} className={styles.root}>
        <DefaultPhoneInputField
          label="Телефонен номер"
          className={styles.root_phone_field}
          name={nameof<IAddPhoneNumberFormModel>((x) => x.phoneNumber)}
          width={inputMaxWidth}
          required
        />
        <DefaultButton label={"Добави"} type="submit" width={inputMaxWidth} />
        <DefaultButton
          label={"Изход от профила"}
          design={"outline"}
          type="button"
          onClick={logoutToAppointmentWizard}
          width={inputMaxWidth}
        />
      </form>
    </FormProvider>
  );
};
